import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/auth';
import { Layout } from './components/Layout';

const LoginPage = lazy(() => import('./routes/LoginPage').then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import('./routes/RegisterPage').then((m) => ({ default: m.RegisterPage })));
const DashboardPage = lazy(() => import('./routes/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const CharacterPage = lazy(() => import('./routes/CharacterPage').then((m) => ({ default: m.CharacterPage })));
const CampaignPage = lazy(() => import('./routes/CampaignPage').then((m) => ({ default: m.CampaignPage })));
const CharacterCreationPage = lazy(() => import('./routes/character-creation/CharacterCreationPage').then((m) => ({ default: m.CharacterCreationPage })));
const LegalPage = lazy(() => import('./routes/LegalPage').then((m) => ({ default: m.LegalPage })));
const AccountPage = lazy(() => import('./routes/AccountPage').then((m) => ({ default: m.AccountPage })));
const LevelUpPlannerPage = lazy(() => import('./routes/LevelUpPlannerPage').then((m) => ({ default: m.LevelUpPlannerPage })));

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  if (token) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Suspense>
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        }
      />
      <Route path="/legal" element={<LegalPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="characters/new" element={<CharacterCreationPage />} />
        <Route path="characters/:id" element={<CharacterPage />} />
        <Route path="characters/:id/plan" element={<LevelUpPlannerPage />} />
        <Route path="campaigns/:id" element={<CampaignPage />} />
        <Route path="account" element={<AccountPage />} />
      </Route>
    </Routes>
    </Suspense>
  );
}
